(function () {
  if (!document.body.classList.contains('template-index')) return;

  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const REVEAL_RULES = [
    {
      selector: '.cs-sidebar, .cs-hero__content, .pc-header, .sbc-header, .wi-header, .tr-header, .br-header, .faq-intro, .bb-head',
      animation: 'fade-up',
    },
    {
      selector: '.cs-hero__media',
      animation: 'slide-left',
    },
    {
      selector: '.sbc-promo__body',
      animation: 'slide-right',
    },
    {
      selector: '.sbc-promo__media',
      animation: 'slide-left',
    },
    {
      selector: '.dlv__content',
      animation: 'fade-up',
    },
    {
      selector: '.dlv__orb',
      animation: 'scale-in',
      stagger: 120,
    },
    {
      selector: '.bb-side, .bb-tab-system',
      animation: 'slide-left',
    },
    {
      selector: '.cs-category, .cs-promo, .wi-card, .fh-card, .sbc-cat, .sbc-feature, .pc-card, .tr-card, .br-card, .pb-card, .faq-item, .bb-card',
      animation: 'fade-up',
      stagger: 70,
    },
    {
      selector: '.tc-slide__left',
      animation: 'slide-right',
    },
    {
      selector: '.tc-slide__right',
      animation: 'slide-left',
    },
  ];

  function applyRevealClasses(root) {
    if (REDUCED_MOTION) return;

    const seen = new WeakSet();

    REVEAL_RULES.forEach((rule) => {
      const parents = new Map();

      root.querySelectorAll(rule.selector).forEach((el) => {
        if (seen.has(el) || el.closest('.hp-reveal')) return;
        seen.add(el);

        el.classList.add('hp-reveal', `hp-reveal--${rule.animation}`);

        if (rule.stagger) {
          const parent = el.parentElement;
          if (!parent) return;
          const index = parents.get(parent) || 0;
          parents.set(parent, index + 1);
          el.style.setProperty('--hp-delay', `${Math.min(index * rule.stagger, 560)}ms`);
        }
      });
    });
  }

  function revealElement(el) {
    el.classList.add('is-visible');
  }

  function initObserver(root) {
    const elements = root.querySelectorAll('.hp-reveal:not(.is-visible)');
    if (!elements.length) return;

    if (REDUCED_MOTION) {
      elements.forEach(revealElement);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealElement(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    elements.forEach((el) => observer.observe(el));
  }

  function init(root = document) {
    applyRevealClasses(root);
    initObserver(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  }
})();
